const atualizarEmpresas = (state, empresas) => {
    state.empresas = empresas;
}

const atualizarEmpresa = (state, empresa) => {
    state.empresa = empresa;
}

export default {
    atualizarEmpresas,
    atualizarEmpresa
}